function checkWarrantyStatus(dateString) {
  let [day, month, year] = dateString.split('/');
  const inputDateObj = new Date(+year + 2000, +month - 1, +day);
  const currentDate = new Date();

  const timeDifference = inputDateObj - currentDate;
  const twoYearsInMilliseconds = 2 * 365 * 24 * 60 * 60 * 1000;

  if (timeDifference >= twoYearsInMilliseconds) {
    return MANUFACTURERS_WARRANTY;
  } else if (timeDifference >= 0) {
    return EXTENDED_WARRANTY;
  } else {
    return OUT_WARRANTY;
  }
}

function commonHandleSelectedChoice(choices) {
  const modelType = this.$store.getters.getProductData.modelType;

  this.$store.commit('updateIssues', choices);

  // Remove additional information tags which are no longer valid
  const additionalInformation =
    this.$store.getters.getFormData.additionalInformation;

  const updatedAdditionalInformation = additionalInformation.filter((tag) => {
    const issue = ADDITIONAL_INFORMATION_CONFIGS.find(
      (item) =>
        item.products.includes(modelType) &&
        item.questions.some((question) =>
          question.choices.some((choice) => choice.tag === tag),
        ),
    );

    return choices.includes(issue.issue_tag);
  });

  this.$store.commit(
    'updateAdditionalInformation',
    updatedAdditionalInformation,
  );

  this.$store.commit(
    'updateConfirmDisabled',
    this.$store.getters.getFormData.issues.length === 0,
  );
}

function commonNext(currentIssueTag, currentQuestionIndex = -1) {
  const umbrellaType = store.getters.getProductData.modelType;
  const issues = store.getters.getFormData.issues.map((i) => i);
  const additionalInformation = store.getters.getFormData.additionalInformation;

  let nextIssueIndex = currentIssueTag
    ? issues.findIndex((e) => e === currentIssueTag)
    : 0;
  let nextIssue = null;
  let nextQuestion = null;
  let nextQuestionIndex = currentQuestionIndex + 1;

  do {
    nextIssue = ADDITIONAL_INFORMATION_CONFIGS.find(
      (item) =>
        item.products.includes(umbrellaType) &&
        item.issue_tag === issues[nextIssueIndex],
    );
    nextQuestion = nextIssue?.questions?.[nextQuestionIndex];

    if (nextIssue == null || nextQuestion == null) {
      nextIssueIndex++;
      nextQuestionIndex = 0;
    }
  } while (nextQuestion == null && nextIssueIndex < issues.length);

  if (nextQuestion == null) {
    store.commit('updateRepairMethod', '');

    // Revalidate and remove any invalid additionaInformations
    let updatedAdditionalInformation = [...additionalInformation];

    for (const issueTag of store.getters.getFormData.issues) {
      const issueConfig = ADDITIONAL_INFORMATION_CONFIGS.find(
        (item) =>
          item.products.includes(umbrellaType) && item.issue_tag === issueTag,
      );

      if (issueConfig) {
        for (const question of issueConfig.questions) {
          if (question.when != null) {
            const validQuestion = question.when.every((tag) =>
              updatedAdditionalInformation.includes(tag),
            );
            if (!validQuestion) {
              const choiceTags = question.choices.map((c) => c.tag);

              // Remove invalid choices
              updatedAdditionalInformation =
                updatedAdditionalInformation.filter(
                  (t) => !choiceTags.includes(t),
                );
            }
          }
        }
      }
    }

    if (updatedAdditionalInformation.length !== additionalInformation.length) {
      store.commit('updateAdditionalInformation', updatedAdditionalInformation);
    }

    return {
      name: 'repair-options',
    };
  }

  if (nextQuestion.when) {
    const matched = nextQuestion.when.every((tag) =>
      additionalInformation.includes(tag),
    );
    if (!matched) {
      return commonNext(nextIssue.issue_tag, nextQuestionIndex + 1);
    }
  }

  return {
    name: 'additional-information',
    query: {
      issue: nextIssue.issue_tag,
      index: nextQuestionIndex,
    },
  };
}

function repairNext() {
  return {
    name: store.getters.getRepairData.method,
  };
}

function toKebabCase(text) {
  return text
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();
}

function getPartsAndPrices(model, issue, matchingCases, sku) {
  let bluntPartsAndPrices = [];
  let customerPartsAndPrices = [];

  matchingCases.forEach((c) => {
    if (c.blunt_repair) {
      bluntPartsAndPrices.push({
        part: `${model.toLowerCase()}-${toKebabCase(issue)}${c.blunt_cost == 0 ? '--free' : ''
          }`,
        price: c.blunt_cost,
        variant: sku,
      });
    }
    if (c.customer_repair) {
      customerPartsAndPrices.push({
        part: `${model.toLowerCase()}-${toKebabCase(issue)}${c.customer_cost == 0 ? '--free' : ''
          }`,
        price: c.customer_cost,
        variant: sku,
      });
    }
  });

  return {
    ifBluntRepairs: bluntPartsAndPrices,
    ifCustomerRepairs: customerPartsAndPrices,
  };
}

// function checkPossibilities(model, warranty, issues, additionalInformation) {
function checkPossibilities() { }

/* Step 1 component */
const selectRepair = {
  path: '/select-a-repair',
  component: {
    template: '#repair-select',
    mounted() {
      this.$store.commit('updatebackDisabled', true);
      this.$store.commit(
        'updateConfirmDisabled',
        this.$store.getters.getFormData.issues.length === 0,
      );
    },
    data() {
      const umbrellaType = this.$store.getters.getProductData.modelType.toLowerCase();
      const preSelected = this.$store.getters.getFormData.issues.map((t) => t);

      if (umbrellaType.includes('metro')) {
        const returnObject = {
          choices: METRO_ISSUES,
          preSelected: preSelected,
        };

        return returnObject;
      } else {
        return {
          choices: NON_METRO_ISSUES,
          preSelected: preSelected,
        };
      }
    },
    methods: {
      handleSelectedChoice: commonHandleSelectedChoice,
      skipToPartSelect() {
        this.$router.push({ name: 'broken-part' });
        window.scrollTo({
          top: 0,
          behavior: 'instant',
        });
      },
    },
  },
  next: commonNext,
};

/* Step 2 component */
const brokenParts = {
  path: '/which-part-is-broken',
  component: {
    template: '#broken-part',
    mounted() {
      this.$store.commit('updatebackDisabled', false);
      this.$store.commit(
        'updateConfirmDisabled',
        this.$store.getters.getFormData.issues.length === 0,
      );
    },
    data() {
      const umbrellaType = this.$store.getters.getProductData.modelType.toLowerCase();
      const preSelected = this.$store.getters.getFormData.issues.map((t) => t);
      const isMetro = umbrellaType.includes('metro');
      const data = {
        backdropSide:
          isMetro
            ? METRO_SKELETON_SIDE.backdrop
            : CLASSIC_SKELETON_SIDE.backdrop,
        choicesSide:
          isMetro
            ? METRO_SKELETON_SIDE.checkboxes
            : CLASSIC_SKELETON_SIDE.checkboxes,
        backdropTop:
          isMetro
            ? METRO_SKELETON_TOP.backdrop
            : CLASSIC_SKELETON_TOP.backdrop,
        choicesTop:
          isMetro
            ? METRO_SKELETON_TOP.checkboxes
            : CLASSIC_SKELETON_TOP.checkboxes,
        preSelected: preSelected,
        topSelection: [],
        sideSelection: [],
      };

      preSelected.forEach((issue) => {
        if (data.choicesSide.map((i) => i.tag).includes(issue))
          data.sideSelection.push(issue);
        if (data.choicesTop.map((i) => i.tag).includes(issue))
          data.topSelection.push(issue);
      });

      return data;
    },
    methods: {
      handleTopSelectedChoices(selections) {
        console.log('TOP SELECTIONS: ', selections);

        this.topSelection = selections;
        this.handleSelectionChoices(
          this.topSelection.concat(this.sideSelection),
        );
      },
      handleSideSelectionChoices(selections) {
        console.log(
          'SIDE SELECTIONS: ',
          selections,
          this.topSelection,
          this.sideSelection,
        );

        this.sideSelection = selections;
        this.handleSelectionChoices(
          this.topSelection.concat(this.sideSelection),
        );
      },
      handleSelectionChoices: commonHandleSelectedChoice,
    },
  },
  next: commonNext,
};

/* Step 3 component */
const additionalInformation = {
  path: '/additional-information',
  component: {
    template: '#additional-information',
    mounted() {
      this.$store.commit('updatebackDisabled', false);
      this.$store.commit(
        'updateConfirmDisabled',
        this.$store.getters.getFormData.additionalInformation.length === 0,
      );
    },
    computed: {
      choices() {
        const umbrellaType = this.$store.getters.getProductData.modelType;
        const issue = this.$route.query.issue;
        const index = Number(this.$route.query.index ?? 0);

        const config = ADDITIONAL_INFORMATION_CONFIGS.find(
          (item) =>
            item.products.includes(umbrellaType) && item.issue_tag === issue,
        );

        return config?.questions?.[index]?.choices ?? [];
      },
      preSelected() {
        return this.$store.getters.getFormData.additionalInformation.map(
          (t) => t,
        );
      },
    },
    methods: {
      handleSelectedChoice(choices) {
        const choicesTags = choices.map((c) => c);
        const currentIssueChoices = this.choices.map((i) => i.tag);

        let updatedIssues =
          this.$store.getters.getFormData.additionalInformation.map((i) => i);

        currentIssueChoices.forEach((currentIssueChoice) => {
          if (choicesTags.includes(currentIssueChoice)) {
            if (!updatedIssues.includes(currentIssueChoice)) {
              updatedIssues.push(currentIssueChoice);
            }
          } else {
            const index = updatedIssues.indexOf(currentIssueChoice);
            if (index === -1) return;
            updatedIssues.splice(index, 1);
          }
        });

        this.$store.commit('updateAdditionalInformation', updatedIssues);

        this.$store.commit(
          'updateConfirmDisabled',
          this.$store.getters.getFormData.additionalInformation.length === 0,
        );
      },
    },
  },
  next: commonNext,
};

const repairOptions = {
  path: '/repair-options',
  component: {
    template: '#repair-options',
    mounted() {
      const method = this.$store.state.repair.method;

      this.$store.commit('updatebackDisabled', false);
      this.$store.commit(
        'updateConfirmDisabled',
        method == null || method === '',
      );
    },
    methods: {
      updateRepairMethod(method) {
        this.$store.commit('updateRepairMethod', method);
        this.$store.commit('updateConfirmDisabled', false);
      },
    },
    computed: {
      cards() {
        const output = this.$store.getters.getPossibilities;

        return [
          {
            handle: 'repair-diy',
            title: 'Repair it yourself!',
            description:
              'If it’s an easy fix and you’re keen to roll up your sleeves, we can send you new parts to fix your BLUNT.',
            disabled: !output.customerCanRepair,
          },
          {
            handle: 'repair-blunt',
            title: 'Send it in to BLUNT',
            description: `If it's a bit more of a complicated repair and or if you would like this repaired by our team.`,
            disabled: !output.bluntCanRepair,
          },
        ];
      },
      repairData() {
        return this.$store.getters.getRepairData;
      },
      selectedParts() {
        const partsNeeded = this.$store.getters.getPartsNeeded;

        return partsNeeded.map((part) => part.title);
      },
    },
  },
  next: repairNext,
};

let repairDIYInstance = null;

const repairDIY = {
  path: '/repair-diy',
  component: {
    template: '#repair-diy',
    mounted() {
      repairDIYInstance = this;
      this.$store.commit('updatebackDisabled', false);

      let appliedShippingDiscount = false;

      /**
       * Apply discount if manufacturer's warranty
       */
      const warranty = store.getters.getProductData.warranty;
      if (!appliedShippingDiscount) {
        if (warranty == MANUFACTURERS_WARRANTY) {
          window?.liquidAjaxCart?.cartRequestUpdate?.({
            attributes: {
              '_free-shipping': '1',
            },
          });
        } else {
          window?.liquidAjaxCart?.cartRequestUpdate?.({
            attributes: {
              '_free-shipping': null,
            },
          });
        }

        appliedShippingDiscount = true;
      }
    },
    data() {
      let success = false;

      return { success, componentInstance: 'test' };
    },
    computed: {
      model() {
        return this.$store.getters.getProductData.modelType;
      },
      products() {
        return this.$store.getters.getPartsNeeded;
      },
    },
    methods: {
      increment(product) {
        if (product.quantity < product.max_order_quantity) {
          product.quantity += 1;
        }
      },
      decrement(product) {
        if (product.quantity > 0) {
          product.quantity -= 1;
        }
      },
      updateRepairMethod(method) {
        this.$store.commit('updateRepairMethod', method);
      },

      addPartsToCart() {
        const { cart } = window?.liquidAjaxCart?.getCartState();
        let partsNeeded = store.getters.getPartsNeeded;
        partsNeeded = partsNeeded.filter((product) => !product.error);

        const setSuccess = (newVal) => {
          this.success = newVal;
          store.commit('updateHideNav', true);

          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });

          setTimeout(function () {
            window.location.href = '/checkout';
          }, 7000);
        };

        let discountVariants = [];
        partsNeeded.forEach((product) => {
          if (product.isFree) {
            discountVariants.push(product.variant_id);
          }
        });

        let items = [];
        const updates = {};

        if (store.state.productData.warranty === 'OUT') {
          // Remove previously added free repair parts if selected product is out of warranty
          for (const item of cart.items) {
            if ('_repair' in item.properties) {
              updates[item.key] = 0;
            }
          }
        }

        partsNeeded.forEach((part) => {
          let item = {
            id: part.variant_id,
            quantity: 1,
            properties: {
              _repair: new URLSearchParams(window.location.search).get('id'),
            },
          };

          item.properties['_free-part'] = part.isFree ? '1' : '0';

          updates[part.variant_id] = part.quantity || 1;

          items = [item, ...items];
        });

        const updateButton = (loading) => {
          store.commit(
            'updateCustomButtonLabel',
            loading ? 'Adding to cart...' : '',
          );
          store.commit('updateConfirmDisabled', loading);
        };

        function addToCart() {
          updateButton(true);

          if (items.length) {
            window?.liquidAjaxCart?.cartRequestAdd(
              {
                items,
              },
              {
                lastComplete: () => {
                  window?.liquidAjaxCart?.cartRequestUpdate(
                    {
                      updates,
                    },
                    {
                      firstComplete: () => {
                        document.body.classList.remove('cart-drawer--show');
                      },
                      lastComplete: () => {
                        document.body.classList.remove('cart-drawer--show');
                        updateButton(false);
                        setSuccess(true);
                      },
                    },
                  );
                },
              },
            );
          }
        }

        addToCart();

        return null;
      },
    },
  },
  next: () => {
    // this.component.methods.addPartsToCart().call(this);
    // console.log(this.componentInstance)
    // console.log({ repairDIYInstance })

    repairDIYInstance.addPartsToCart.call(repairDIYInstance);

    return '/repair-diy';
  },
};

let repairBluntComponent = null;
let $repairBluntForm = null;

const repairBlunt = {
  path: '/repair-blunt',
  component: {
    template: '#repair-blunt',
    mounted() {
      repairBluntComponent = this;
      this.$store.commit('updatebackDisabled', false);
      this.$store.commit('updateConfirmDisabled', false);

      const $supportingImage = document.querySelector('#supporting_image');
      const widget = uploadcare.SingleWidget($supportingImage);
      widget.onUploadComplete((info) => {
        this.image_error = false;
      });
    },
    data() {
      let success = false;
      let error_message = '';
      const product = window.repairProducts[product_id];
      const address = window?.customerAddress;

      const form = {
        product_id: product.id,
        product_name: product.title,
        product_colour: product.colour_name,
        product_expiry: product.expiry_date,

        send_method: '',
        receive_method: '',

        first_name: address?.first_name || '',
        last_name: address?.last_name || '',

        phone_number: address?.phone || '',
        email: window?.customerEmail || '',
        customer_email: window?.customerEmail || '',
        country: address?.country || 'New Zealand',

        street: address?.address1 || '',
        building: '',
        suburb: address?.address2 || '',
        postcode: address?.zip || '',
        city: address?.city || '',

        additional_comments: '',
        signature_required: 'NO',

        batch_code: product.batch_code,
        model: product.title,
        colour: product.colour_name,
        proof_of_purchase:
          product.type == 'metaobject'
            ? product.purchase_proof || 'N/A'
            : 'Purchased online',
        expiry_date: product.expiry_date,
        // selected_parts: store.getters.getSelectedParts.join(', ')
        // supporting_image: '',
      };

      let image_error = false;

      return { form, success, error_message, image_error };
    },
    computed: {
      warranty() {
        console.log('warranty', this.$store);

        return this.$store.getters.getProductData.warranty;
      },
    },
    methods: {
      onSupportingImageChange(event) {
        console.log('onSupportingImageChange', event);
      },
      submit() {
        // console.log(this.form);
        const supporting_image =
          document.querySelector('#supporting_image').value;

        if (!supporting_image) {
          this.image_error = true;

          return;
        } else {
          this.image_error = false;
        }

        if (this.$refs.form.reportValidity()) {
          this.$store.commit('updateConfirmDisabled', true);

          axios
            .post('/apps/blunt/repair/2.0/repair-blunt', {
              ...this.form,
              selected_parts: store.getters.getSelectedParts.join(', '),
              supporting_image: supporting_image,
              status: 'Initiated',
            })
            .then(({ data }) => {
              if (data?.success) {
                this.success = true;
                store.commit('updateHideNav', true);

                window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
              }

              if (data?.error) {
                this.error_message = data.error;
              }
            })
            .finally(() => {
              this.$store.commit('updateConfirmDisabled', false);
            });
        }
      },
    },
  },
  next: function () {
    repairBluntComponent.submit();

    return repairNext();
  },
};

let repairEnquireComponent = null;
const repairEnquire = {
  path: '/repair-enquire',
  component: {
    template: '#repair-enquire',
    mounted() {
      repairEnquireComponent = this;
      this.$store.commit('updateConfirmDisabled', false);
      this.$store.commit('updatebackDisabled', true);
      this.$store.commit('updateHideNav', true);

      const copy = window.repairEnquireFormCopy;
      if (copy) {
        const h = this.$el?.querySelector?.('#repair_product-form-heading');
        const s = this.$el?.querySelector?.('#repair_product-form-subheading');
        if (h) h.innerText = copy.form_heading.replaceAll('&#39;', "'");
        if (s) s.innerText = copy.form_subheading.replaceAll('&#39;', "'");
      }

      const formEl = this.$el?.querySelector?.('#repairs-form') || document.getElementById('repairs-form');
      if (formEl) {
        formEl.addEventListener('submit', (e) => {
          e.preventDefault();

          formEl.classList.add('is-loading');

          const params = new URLSearchParams();
          const fd = new FormData(formEl);
          for (const [key, value] of fd.entries()) {
            params.append(key, value);
          }

          axios
            .post(formEl.getAttribute('action'), params)
            .then(({ data }) => {
              formEl.classList.remove('is-loading');

              if (data?.success) {
                this.success = true;
                store.commit('updateHideNav', true);
                document.body.classList.add('repairs-form--success');
              } else {
                const errorMessage = data?.error || 'Some unknown error occurred.';
                const messageBox = formEl.querySelector('.repairs-form__message');
                if (messageBox) {
                  messageBox.innerHTML = `<div>${errorMessage}</div>`;
                }
              }
            })
            .catch(() => {
              formEl.classList.remove('is-loading');
              const messageBox = formEl.querySelector('.repairs-form__message');
              if (messageBox) {
                messageBox.innerHTML = `<div>Some unknown error occurred.</div>`;
              }
            });
        });
      }
    },
    data() {
      let success = false;
      const productData = this.$store.getters.getProductData;
      const product = window.repairProducts[product_id];
      let isVIP = productData.modelType == 'tempus';
      let error_message = '';

      let form = {
        product_id: product.id,
        product_name: product.title,
        product_colour: product.colour_name,
        product_expiry: product.expiry_date,

        first_name: window?.customerFirstName || '',
        last_name: window?.customerLastName || '',
        customer_email: window?.customerEmail || '',

        is_vip: isVIP,
      };

      return { isVIP, success, form, error_message };
    },
    methods: {
      submit() {
        const productData = this.$store.getters.getProductData;
        let isVIP = productData.modelType == 'tempus';

        console.log({ productData });

        this.form.image = this.$refs.fileInput.value;
        console.log(this.form);

        if (this.$refs.form.reportValidity()) {
          this.$store.commit('updateConfirmDisabled', true);

          if (isVIP) {
            // Submit response to formspark, if Tempus
            axios
              .post('https://submit-form.com/jiOQouH1B', this.form)
              .then(({ data }) => {
                this.success = true;
                store.commit('updateHideNav', true);

                window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
              })
              .catch(() => {
                this.error_message = 'Some error occured';
              })
              .finally(() => {
                this.$store.commit('updateConfirmDisabled', false);
              });
          } else {
            axios
              .post('/apps/blunt/repair/2.0/repair-enquire', this.form)
              .then(({ data }) => {
                if (data?.success) {
                  this.success = true;
                  store.commit('updateHideNav', true);

                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                  });
                }

                if (data?.error) {
                  this.error_message = data.error;
                }
              })
              .finally(() => {
                this.$store.commit('updateConfirmDisabled', false);
              });
          }
        }
      },
    },
  },
  next: function () {
    const formEl = document.getElementById('repairs-form');
    if (formEl) {
      if (typeof formEl.requestSubmit === 'function') {
        formEl.requestSubmit();
      } else {
        formEl.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    }


    return '/repair-enquire';
  },
};

const steps = {
  'repair-select': selectRepair,
  'broken-part': brokenParts,
  'additional-information': additionalInformation,
  'repair-options': repairOptions,
  'repair-diy': repairDIY,
  'repair-blunt': repairBlunt,
  'repair-enquire': repairEnquire,
};

const stepProgress = {
  'repair-select': 1,
  'broken-part': 2,
  'additional-information': 2,
  'repair-options': 2,
  'repair-diy': 3,
  'repair-blunt': 3,
  'repair-enquire': 3,
};

/* For managing state */
const store = new Vuex.Store({
  state: {
    navigation: {
      backDisabled: true,
      confirmDisabled: true,
      currentStep: null,
      customButtonLabel: '',
      hideNav: false,
    },
    formData: {
      issues: [],
      additionalInformation: [],
    },
    productData: {
      // modelType: CLASSIC,
      // warranty: MANUFACTURERS_WARRANTY,

      modelType: window.repairProducts[product_id].model,
      warranty: checkWarrantyStatus(
        window.repairProducts[product_id].expiry_date,
      ),
    },
    repair: {
      method: '',
      partsNeeded: [],
    },
    dropdownChoices: {},
    steps: {
      total: 3,
      current: 1,
    },
  },
  mutations: {
    updateSteps(state, newValue) {
      state.steps = { ...state.steps, ...newValue };
    },
    updatebackDisabled(state, newValue) {
      state.navigation.backDisabled = newValue;
    },
    updateConfirmDisabled(state, newValue) {
      state.navigation.confirmDisabled = newValue;
    },
    updateCurrentStep(state, newValue) {
      state.navigation.currentStep = newValue;
    },
    updateIssues(state, newValue) {
      state.formData.issues = newValue;
    },
    updateAdditionalInformation(state, newValue) {
      state.formData.additionalInformation = newValue;
    },
    updateRepairMethod(state, newValue) {
      state.repair.method = newValue;
    },
    updateCustomButtonLabel(state, newValue) {
      state.navigation.customButtonLabel = newValue;
    },
    updateHideNav(state, newValue) {
      state.navigation.hideNav = newValue;
    },
    updateDropdownChoices(state, newValue) {
      state.dropdownChoices = { ...state.dropdownChoices, ...newValue };
    },
  },
  getters: {
    getSteps(state) {
      return state.steps;
    },
    getDropdownChoices(state) {
      const arrays = Object.values(state.dropdownChoices);
      return [].concat(...arrays);
    },
    getNavigation(state) {
      return state.navigation;
    },
    getHideNav(state) {
      return state.navigation.hideNav;
    },
    getFormData(state) {
      return state.formData;
    },
    getProductData(state) {
      return state.productData;
    },
    getRepairData(state) {
      return state.repair;
    },
    getPartsNeeded(state) {
      let currentModelColor = window.repairProducts[product_id]?.colour_name
        .replace(/\s/g, '')
        .toLowerCase();

      if (window.repairProducts[product_id]?.model == 'sport') {
        currentModelColor = currentModelColor.split('/')[0];
      }

      const output = store.getters.getPossibilities;
      const partsRequired = output?.ifCustomerRepairs || [];

      let products = [];

      partsRequired.forEach(({ part, variant: variantSku }) => {
        let handle = part.trim();

        if (handle.includes('canopy')) {
          handle = 'canopy-patch';
        }

        handle = handle.split('--free')[0];

        if (handle.includes('-tip')) {
          handle = `${handle}-spring`;
        }

        let product = window.repairParts[handle];

        if (!product) {
          product = {
            title: `Error: Repair part not found: [${handle}]`,
          };

          product.error = true;
        } else if (handle == 'canopy-patch') {
          let matchFound = false;

          // Define color mapping system
          const colorMappings = {
            inkblack: 'black',
            midnightnavy: 'navy',
            stormgrey: 'charcoal',
            forestgreen: 'green',
            citrusyellow: 'yellow',
          };

          // Clean and map the color
          const getBaseColor = (color) => {
            // Remove spaces, hyphens and convert to lowercase
            const cleanedColor = color.replace(/[\s-]+/g, '').toLowerCase();
            console.log('Cleaned color:', cleanedColor);

            // Return mapped color if it exists, otherwise return cleaned color
            const mappedColor = colorMappings[cleanedColor];
            console.log({
              originalColor: color,
              cleanedColor: cleanedColor,
              mappedColor: mappedColor || cleanedColor,
            });

            return mappedColor || cleanedColor;
          };

          const targetColor = getBaseColor(currentModelColor);
          console.log('Final target color:', targetColor);

          product.product.variants.forEach((variant) => {
            const variantColor = variant.title
              .replace(/[\s-]+/g, '')
              .toLowerCase();
            // console.log('Comparing:', {
            //   original: variant.title,
            //   cleaned: variantColor,
            //   targetColor,
            //   matches: variantColor === targetColor,
            // });

            if (variantColor === targetColor) {
              matchFound = true;
              product.image_url = variant.featured_image.src;
              product.variant_id = variant.id;
            }
          });

          if (!matchFound) {
            product.message = `Please note: we don’t have limited edition canopy patches. Please get in touch with our Customer service team if you do not wish to have a black canopy patch. An iron is required to complete this repair yourself.`;
          } else {
            product.message = `Please note: an iron is required to complete this repair yourself.`;
          }
        } else {
        }

        // Find matching variants
        if (variantSku) {
          const repairPart = Object.values(window.repairParts).find((item) => {
            return item.product.variants.some((v) => v.sku === variantSku);
          });

          if (repairPart) {
            product = repairPart;

            const variant =
              repairPart.product.variants.find(
                (item) => item.sku === variantSku,
              ) ?? repairPart.product.variants[0];

            if (variant) {
              product.variant_id = variant.id;
              product.image_url =
                variant?.featured_image?.src ??
                repairPart?.product?.featured_image;
            }
          }
        }

        if (part.includes('--free')) {
          product.isFree = true;
        }

        product.quantity = 1;

        if (handle.endsWith('-strap') || handle.endsWith('-handle')) {
          const isHandleAdded = products.some((item) =>
            item.product.handle.endsWith('-handle'),
          );

          if (isHandleAdded) {
            return;
          }
        }

        products.push(product);
      });

      return products;
    },
    getCustomButtonLabel(state) {
      return state.navigation.customButtonLabel;
    },
    getPossibilities(state) {
      const model = store.getters.getProductData.modelType;
      const warranty = store.getters.getProductData.warranty;
      const issues = store.getters.getFormData.issues;
      const additionalInformation =
        store.getters.getFormData.additionalInformation;

      const modelMatrix = REPAIR_POSSIBILITY_MATRIX[model];

      let customerRepairPossible = true;
      let bluntRepairPossible = true;
      let partsAndPrices = {
        ifBluntRepairs: [],
        ifCustomerRepairs: [],
      };

      issues.forEach((issue) => {
        const issueMatrix = modelMatrix[issue];

        const matchingCases = issueMatrix.filter((e) => {
          if (warranty !== e.warranty) return false;
          if (e.variation === null) return true;

          return additionalInformation.includes(e.variation);
        });

        const issueConfig = ADDITIONAL_INFORMATION_CONFIGS.find(
          (item) => item.products.includes(model) && item.issue_tag === issue,
        );

        let variantSku = null;
        if (issueConfig?.partVariants) {
          // determine the part variant to use based on the additional info given
          const matchedPartVariant = issueConfig.partVariants.find(
            (partVariant) => {
              const { taggedWith = [], productIn = [] } = partVariant?.when ?? {};
              const productMatched =
                productIn.length === 0 || productIn.includes(model);

              return (
                taggedWith.every((tag) =>
                  additionalInformation.includes(tag),
                ) && productMatched
              );
            },
          );

          if (matchedPartVariant) {
            variantSku = matchedPartVariant.sku;
          }
        }

        const currentIssuePartsAndPrices = getPartsAndPrices(
          model,
          issue,
          matchingCases,
          variantSku,
        );

        partsAndPrices.ifBluntRepairs = partsAndPrices.ifBluntRepairs.concat(
          currentIssuePartsAndPrices.ifBluntRepairs,
        );
        partsAndPrices.ifCustomerRepairs =
          partsAndPrices.ifCustomerRepairs.concat(
            currentIssuePartsAndPrices.ifCustomerRepairs,
          );

        matchingCases.forEach((c) => {
          if (customerRepairPossible) {
            customerRepairPossible = c['customer_repair'];
          }
          if (bluntRepairPossible) {
            bluntRepairPossible = c['blunt_repair'];
          }
        });
      });

      return {
        bluntCanRepair: bluntRepairPossible,
        customerCanRepair: customerRepairPossible,
        ifBluntRepairs: bluntRepairPossible
          ? partsAndPrices.ifBluntRepairs
          : null,
        ifCustomerRepairs: customerRepairPossible
          ? partsAndPrices.ifCustomerRepairs
          : null,
      };
    },

    getSelectedParts(state) {
      return state.formData.issues
        .map((item) => item.replaceAll('_', ' ').toLowerCase())
        .filter((item) => item != 'strap');
    },
  },
});

document.addEventListener('DOMContentLoaded', function () {
  if (store.getters.getProductData.warranty == OUT_WARRANTY) {
    $('.repair-it-yourself__sidebar-info-caption.main-warranty').css(
      'display',
      'none',
    );
    $('.selected-product__warranty.main-warranty').text('Warranty Expired');
  }
});

/* For managing navigation */
const routes = Object.keys(steps).map((screenName) => {
  const screen = steps[screenName];

  return {
    name: screenName,
    path: screen.path,
    component: screen.component,
  };
});

const router = VueRouter.createRouter({
  history: VueRouter.createWebHashHistory(),
  routes,
});

function getKeyIndex(obj, targetKey) {
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    if (keys[i] === targetKey) {
      return i;
    }
  }
  // If the key is not found, you may return -1 or any other value to indicate that.
  return -1;
}

router.beforeEach((to, from, next) => {
  store.commit('updateCurrentStep', to.name);
  const currentStep = stepProgress[to.name];
  store.commit('updateSteps', {
    current: currentStep,
  });

  next();
});

/* Vue app */
const app = Vue.createApp({
  store,
  mounted() {
    this.handleStepsChange(this.$store.getters.getSteps);

    this.$watch(
      () => this.$store.getters.getSteps,
      (newValue, oldValue) => {
        this.handleStepsChange(newValue);
      },
    );

    // syncSteps(this.$route.name);
  },
  methods: {
    handleStepsChange({ current, total }) {
      let text = `Step ${current} of ${total}`;
      let progress = (current / total) * 100;

      document.querySelector('#steps-text').textContent = text;
      document.querySelector('#steps-progress').style.width = `${progress}%`;
    },
  },
  computed: {},
});

app.component('repairs-nav', {
  template: '#repairs-nav',
  props: {
    isMobile: Boolean,
    confirmLabel: String,
    fullwidth: Boolean,
  },
  computed: {
    backDisabled() {
      return store.getters.getNavigation.backDisabled;
    },
    confirmDisabled() {
      return store.getters.getNavigation.confirmDisabled;
    },
    hideNav() {
      return store.getters.getHideNav;
    },
    nextButtonLabel() {
      if (store.getters.getCustomButtonLabel) {
        return store.getters.getCustomButtonLabel;
      } else {
        switch (this.$route.name) {
          case 'repair-diy':
            return 'Add to Cart';
          case 'repair-enquire':
            return 'Submit Enquiry';
          default:
            return this.confirmLabel || 'Confirm';
        }
      }
    },
  },
  methods: {
    back: function () {
      router.go(-1);
      window.scrollTo({
        top:
          document.querySelector('.router-view-holder').getBoundingClientRect()
            .top -
          document.querySelector('.navbar').offsetHeight +
          window.scrollY,
        behavior: 'smooth',
      });
    },
    confirm: function () {
      const currentStep = this.$store.getters.getNavigation.currentStep;
      const issue = this.$route.query.issue;
      const index = Number(this.$route.query.index ?? -1);

      const nextStep = steps[currentStep].next(issue, index);

      if (nextStep !== null) {
        router.push(nextStep);

        if (currentStep != 'repair-blunt' && currentStep != 'repair-enquire') {
          window.scrollTo({
            top:
              document
                .querySelector('.router-view-holder')
                .getBoundingClientRect().top -
              document.querySelector('.navbar').offsetHeight +
              window.scrollY,
            behavior: 'smooth',
          });
        }
      } else {
        const output = this.$store.getters.getPossibilities();

        console.log(output);
        console.log({ issues });
      }
    },
  },
});

function generateUniqueId() {
  return '_' + Math.random().toString(36).substr(2, 9);
}

/* Multiple choice component */
app.component('multiple-choice', {
  template: '#multiple-choice-template',
  props: {
    singleSelect: Boolean,
    choices: Array,
    pickedChoices: Array,
  },
  data() {
    return {
      selectedChoices: [],
      isMobile: window.innerWidth < 768,
      uid: generateUniqueId(),
      model: store.getters.getProductData.modelType,
    };
  },
  mounted() {
    this.choices.forEach((choice) => {
      if (this.pickedChoices.includes(choice.tag)) {
        this.selectedChoices.push(true);
      } else {
        this.selectedChoices.push(false);
      }
    });
  },
  methods: {
    selectChoice(choice) {
      const tag = choice.tag;

      const tagIndex = this.choices.map((c) => c.tag).indexOf(tag);
      const updatedChoices = [];
      for (let i = 0; i < this.selectedChoices.length; i++) {
        if (this.singleSelect && i != tagIndex) this.selectedChoices[i] = false;

        if (this.selectedChoices[i]) updatedChoices.push(this.choices[i].tag);
      }

      this.$emit('choices-selected', updatedChoices);
    },
    isPreSelected(tag) {
      return this.pickedChoices.includes(tag);
    },
  },
});

app.component('skeleton', {
  template: '#multiple-choice-skeleton-template',
  props: {
    backdrop: String,
    choices: Array,
    pickedChoices: Array,
    group: String,
  },
  data() {
    return {
      selectedChoices: [],
      canopyArray: [],
    };
  },
  mounted() {
    this.choices.forEach((choice) => {
      if (this.pickedChoices.includes(choice.tag)) {
        if (choice.tag == 'CANOPY') {
          canopyTag = choice.tag + '--' + choice.label;
          this.canopyArray.push(canopyTag);
        }

        this.selectedChoices.push(choice.tag);
      }
    });

    this.syncDropdown();
  },
  methods: {
    syncDropdown() {
      let selectedChoices = [];
      this.choices.forEach((choice) => {
        if (this.isCurrentlySelected(choice)) {
          selectedChoices.push(this.getChoiceInputId(choice));
        }
      });

      store.commit('updateDropdownChoices', { [this.group]: selectedChoices });
    },
    getChoiceInputId(choice) {
      return window.getChoiceInputId(choice);
    },

    selectChoice(choice) {
      let tag = choice.tag;

      if (tag == 'CANOPY') {
        canopyTag = tag + '--' + choice.label;

        if (this.canopyArray.includes(canopyTag)) {
          this.canopyArray = this.canopyArray.filter((c) => c !== canopyTag);
        } else {
          this.canopyArray.push(canopyTag);
        }

        if (this.canopyArray.length) {
          if (!this.selectedChoices.includes(tag)) {
            this.selectedChoices.push(tag);
          }
        } else {
          this.selectedChoices = this.selectedChoices.filter((c) => c !== tag);
        }
      } else {
        if (this.selectedChoices.includes(tag)) {
          this.selectedChoices = this.selectedChoices.filter((c) => c !== tag);
        } else {
          this.selectedChoices.push(tag);
        }
      }

      console.log(this.canopyArray);
      console.log(this.selectedChoices);

      this.$emit('choices-selected', this.selectedChoices);
      this.syncDropdown();
    },

    isPreSelected(choice) {
      let tag = choice.tag;
      let isSelected = this.pickedChoices.includes(tag);

      if (tag == 'CANOPY') {
        let canopyTag = tag + '--' + choice.label;
        isSelected = this.canopyArray.includes(canopyTag);
      }

      return isSelected;
    },

    isCurrentlySelected(choice) {
      let tag = choice.tag;
      let isSelected = this.selectedChoices.includes(tag);

      if (tag == 'CANOPY') {
        let canopyTag = tag + '--' + choice.label;
        isSelected = this.canopyArray.includes(canopyTag);
      }

      return isSelected;
    },
  },
});

app.component('skeleton-dropdown', {
  template: '#skeleton-dropdown',
  props: {
    choices: Array,
  },
  data() {
    return {
      selectedChoices: [],
      canopyArray: [],
      showDropdown: false,
    };
  },
  mounted() {
    // this.choices.forEach((choice) => {
    //   if (this.pickedChoices.includes(choice.tag)) {
    //     if( choice.tag == 'CANOPY' ) {
    //       canopyTag = choice.tag + '--' + choice.label;
    //       this.canopyArray.push(canopyTag);
    //     }
    //     this.selectedChoices.push(choice.tag);
    //   }
    // });
  },
  computed: {
    label() {
      let label = 'Select a Part';
      const selectedIds = this.$store.getters.getDropdownChoices;

      if (selectedIds.length > 0) {
        label = `${selectedIds.length} Part${selectedIds.length == 1 ? '' : 's'
          } Selected`;
      }

      return label;
    },
  },
  methods: {
    isSelected(choice) {
      const selectedIds = this.$store.getters.getDropdownChoices;
      console.log({ selectedIds });
      return selectedIds.includes(this.getChoiceInputId(choice));
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;

      if (this.showDropdown) {
        document.addEventListener('click', this.handleDocumentClick);
      } else {
        document.removeEventListener('click', this.handleDocumentClick);
      }
    },

    handleDocumentClick(event) {
      console.log(this.$refs.dropdown);
      console.log(event.target);
      console.log(this.$refs.dropdown.contains(event.target));

      if (!this.$refs.dropdown.contains(event.target)) {
        this.showDropdown = false;
        document.removeEventListener('click', this.handleDocumentClick);
      }
    },

    toggleInput(inputId) {
      const target = window[inputId];
      target.checked = !target.checked;
      target.dispatchEvent(new Event('change'));
    },

    getChoiceInputId(choice) {
      return window.getChoiceInputId(choice);
    },
  },
});

/* Initialisation */
app.use(router);
app.use(store);
app.mount('#app');

// const invalid

let firstStep = 'repair-select';

const currentModel = window.repairProducts[product_id].model;
const validModels = ['classic', 'metro', 'coupe', 'exec', 'sport'];

if (!validModels.includes(currentModel)) {
  firstStep = 'repair-enquire';
}

store.commit('updateCurrentStep', firstStep);
router.push(steps[firstStep].path);
